import { Divider, Stack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { Services } from './components/Services';
import { ServicesContracts } from './components/ServicesContracts';
import { useListServices } from 'hooks/useApiQueries';
import { trackViewItemList } from 'utils/tracking';
// import { GiftCards } from './components/GiftCards';

function Prices() {
  // Toggle "Activer la nouvelle page Tarifs" piloté depuis le back-office.
  // Quand OFF, le composant Services.tsx legacy reste utilisé tel quel
  // (zéro régression). Quand ON, on bascule sur ServicesContracts qui lit
  // la config admin (window.mondayMindbody.pricingConfig).
  const useNewPricing = typeof mondayMindbody !== 'undefined' && mondayMindbody?.pricingConfig?.enabled === true;

  // GA4 view_item_list : émis dès que la liste des offres est disponible.
  // trackViewItemList no-op si tracking désactivé ou liste vide.
  const { data: services } = useListServices();
  useEffect(() => {
    trackViewItemList(services as unknown as Record<string, unknown>[] | undefined, 'Tarifs');
  }, [services]);

  return (
    <Stack spacing={10}>
      {useNewPricing ? <ServicesContracts /> : <Services />}
      <Divider />
      {/* <GiftCards /> */}
    </Stack>
  );
}

export { Prices };
